import {DataFrame} from 'data-frames/DataFrameTypes';

import {numericAccessor} from './AccessorUtils';
import {createAccessor} from './createAccessors';
import filterRows from './filterRows';

/**
 * Return an array of numbers representing the deserialized values of a numerical column. Null values are ignored.
 */
export function getNumberColumnValues(dataFrame: DataFrame, columnSystemName: string): Array<number> {
  const {accessor, validatedLeafType} = createAccessor(dataFrame, columnSystemName);
  const nullFilteredDataFrame = filterRows(dataFrame, (row) => accessor(row) != null);

  const numberAccessor = numericAccessor(accessor, validatedLeafType);

  return nullFilteredDataFrame.rows.map((row) => numberAccessor(row));
}

/**
 * Return the max value of a numerical columns.
 *
 * Numerical column types have either Integer or Decimal as their leaf types, maybeText and isList set
 * to false, and schemaId unspecified.
 *
 * Nulls can be included and will be ignored. If a Decimal column is given, a deserialized `number` will be
 * returned.
 */
export function getColumnMax(dataFrame: DataFrame, columnSystemName: string): number {
  return Math.max(...getNumberColumnValues(dataFrame, columnSystemName));
}

/**
 * Return the min value of a numerical columns.
 *
 * Numerical column types have either Integer or Decimal as their leaf types, maybeText and isList set
 * to false, and schemaId unspecified.
 *
 * Nulls can be included and will be ignored. If a Decimal column is given, a deserialized `number` will be
 * returned.
 */
export function getColumnMin(dataFrame: DataFrame, columnSystemName: string): number {
  return Math.min(...getNumberColumnValues(dataFrame, columnSystemName));
}
